import React from 'react';
import Sprite from './Sprite';
import { colors } from '../config';

const InfoModalItem = ({ icon, title, children }) => (
  <section>
    {icon && <Sprite icon={icon} />}
    <h1>{title}</h1>
    <div>{children}</div>

    <style jsx>{`
      section {
        border-bottom: 1px solid ${colors.pale};
        margin-bottom: 24px;
        padding-bottom: 24px;
      }

      div > :global(:last-child) {
        margin-bottom: 0 !important;
      }

      h1 {
        font-size: 18px;
        font-weight: bold;
        margin-top: 10px;
        line-height: 1.5;
      }
    `}</style>
  </section>
);

export default InfoModalItem;
